import { queryClient } from '@frontend/sorghum/external-providers';
import { Response } from '@frontend/sorghum/interface';
import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { BILLING } from '../apis';

// 取消「已排定的方案變更」：下期設定還原成現行方案，訂閱本身照常續扣。
// 與 useDeleteBilling（取消整個訂閱）語意分離
async function deleteBillingScheduledChange(): Promise<Response> {
  // 不吞錯：讓錯誤 throw 進 react-query 的 isError/onError（F4，與 401 全域處理同哲學）
  return axios.delete(`${BILLING}/scheduledChange`).then((res) => res.data);
}

export function useDeleteBillingScheduledChange(projectID?: string | null) {
  return useMutation({
    mutationKey: ['delete-billing-scheduled-change', { projectID }],
    mutationFn: () => deleteBillingScheduledChange(),
    onSuccess: (res: Response) => {
      if (res.code === 20000) {
        // 優先用呼叫端傳入的 projectID，sessionStorage 僅為 fallback（Gemini review）
        const id = projectID ?? sessionStorage.getItem('project-id');
        if (id) {
          queryClient.invalidateQueries(['get-billing', { projectID: id }]);
          queryClient.invalidateQueries(['get-billing-payment']);
        }
      }
    },
  });
}

export default useDeleteBillingScheduledChange;
